// This limited custom hook watches for the addition or deletion of a child-node
// in a react container component (which can be anything that can accept children);
// 1st PARAMETER: A reference to the container (parent).
// 2nd PARAMETER: A required callback, which should accept a single parameter.
//   The value passed to this parameter will be one of the following
//       Positive Value n ===> indicates the addition of n child nodes (integer)
//       Negative Value n ===> indicates the removal of n child nodes (integer)
// 3rd PARAMETER: Specify a STRING of either 'addedNodes' or 'removedNodes'.  Otherwise,
// this hook watches for both events by default.

import { useEffect } from 'react';

function useChildElementObserver(parentRef, callback, eventToWatch = ['addedNodes', 'removedNodes']) {
    useEffect(() => {
        const mutationHandler = mutations => {
            let eventArr = eventToWatch;
            if (typeof eventToWatch === 'string') {
                eventArr = [eventToWatch];
            }

            mutations.forEach(mutation => {
                const change = Object.keys(mutation.addedNodes).includes('0') ? Object.keys(mutation.addedNodes).length : -1 * Object.keys(mutation.removedNodes).length;

                if (change > 0 && eventArr.includes('addedNodes') || change < 0 && eventArr.includes('removedNodes')) {
                    callback(change);
                }
            });
        };

        if (parentRef.current) {
            const observer = new MutationObserver(mutationHandler);
            observer.observe(parentRef.current, { childList: true });

            return () => {
                observer.disconnect()
            };
        }
    }, [callback, eventToWatch, parentRef]);
}

export default useChildElementObserver;
